import styles from "./FirstScreen.module.css";
import nikol from "../images/ניקול ביוטי קורס.webp";

const FirstScreen = (props) => {




  return (
    <>
      <div className={styles.background}>
        <div className={!props.scrolled ? styles.question : styles.questionFixed}>
          <span>
            בטוחה שתחום הביוטי <div className={styles.bold}> הוא בול בשבילך </div>
            <br />
            ועדיין מסתכלת מהצד ?
          </span>
        </div>
        <h1 className={styles.title}>הגיע הזמן לעשות את הצעד !</h1>
        <div className={styles.center}>
          <img
            className={styles.image}
            src={nikol}
            alt="ניקול ולארי, מומחית ביוטי, בקליניקה"
            width="518"
            height="455"
            fetchpriority="high"
            decoding="async"
          />
        
        </div>
      </div>
    </>
  );
};

export default FirstScreen;